<h2>Datenschutzerklärung für die Registrierung, Machbarkeitsanfragen, Antragstellung</h2>
<br /><br />
Mit den folgenden Informationen geben wir Ihnen einen Überblick über die Verarbeitung Ihrer
personenbezogenen Daten.
<br />
Die vorliegenden datenschutzrechtlichen Informationen und Regelungen gelten ausschließlich für
Nutzer, die sich beim Deutschen FDPGs für Gesundheit (im Folgenden „FDPG“) registrieren, und
Machbarkeitsanfragen durchführen, sowie Nutzungsanträge bei den beteiligten MII-Standorten
einreichen.
<br />
In der laufenden Testphase ist das FDPG nur berechtigten und registrierten Nutzern im Rahmen der
Medizininformatik-initiative zugänglich (siehe hierzu Nutzungsbedingungen des FDPG unter
https://forschen-fuer-gesundheit.de/nutzungsbedingungen.php).
<br />
<br />
<br />
<br />
<h3>1. Verantwortlichkeit</h3>
Verantwortlicher im Sinne der Datenschutzgrundverordnung ist die:
<br />
TMF – Technologie- und Methodenplattform für die vernetzte medizinische Forschung e.V.,
Charlottenstraße 42, 10117 Berlin, Tel.: 030 / 22 00 24 70
<br />
E-Mail: datenschutz@tmf-ev.de
<br />
Dr. Markus Schneider, Munas Consulting, Flotowstr. 3, 15370 Fredersdorf
<br />
<br />
<br />
<h3>2. Nutzerregistrierung beim FDPG</h3>
(1) Für die Nutzung bestimmter Funktionen des FDPG (wie z.B. die Durchführung von
Machbarkeitsanfragen) ist die vorherige individuelle Registrierung und Freischaltung einer
natürlichen Person als Nutzer erforderlich. Eine Nutzung des Nutzer-Accounts ist nur dem
registrierten Nutzer gestattet. Eine Nutzung des Nutzer-Accounts durch Dritte ist ausdrücklich
untersagt. Der Nutzer haftet für die Nutzung seines Nutzer-Accounts nach den vorliegenden
Bedingungen und im Rahmen der gesetzlichen Regelungen.
<br />
(2) Im Rahmen der Registrierung werden Namens-, Adress- und Institutionsangaben des Nutzers bei
unserem Hoster, Host Europe GmbH, Hansestrasse 111, 51149 Köln gespeichert und verarbeitet.
<br />
Mit dem Hoster wurde ein entsprechender datenschutzrechtlich vorgeschriebener Vertrag zur
Auftragsverarbeitung geschlossen.
<br />
(3) In der aktuell laufenden Aufbau- und Testphase des FDPG werden für die Registrierung,
insbesondere bei bereits über die Open-Source-Software Keycloak vorhandene Nutzerregistrierung eines
Nutzers, dessen Nutzerdaten auf bzw. über unserem Hoster Host Europe gespeichert und verarbeitet.
<br />
(4) Die Rechtsgrundlage für die Verarbeitung der im Zusammenhang mit dem Nutzer-Account erhobenen
und verarbeiteten personenbezogenen Daten ist die informierte Einwilligung des Nutzers (vergl. Art.
6 Abs. 1 a der Datenschutz-Grundverordnung).
<br />
Ist die Verarbeitung personenbezogener Daten zur Erfüllung eines Vertrages bzw. zur Durchführung
vorvertraglicher Maßnahmen erforderlich, dessen Vertragspartei Sie sind, beruht die Verarbeitung auf
Art. 6 Abs. 1 lit. b DSGVO.
<br />
(5) Die bei der Registrierung erhobenen Daten eines Nutzers werden spätestens fünf Jahre nach der
letzten Anmeldung des Benutzers gelöscht.
<br />
<br />
<br />
<h3>3. Datenerfassung bei der Nutzung</h3>
<h4>3.1 Machbarkeitsanfragen</h4>
(1) Bei Durchführung von Machbarkeitsanfragen speichert das FDPG Ihre Anfragen (Query), den
Anfragezeitpunkt und die Ergebnisse der Machbarkeitsanfragen. Das Vorgehen dient einerseits dem
Schutz personenbezogener Daten, beschleunigt außerdem die Antwort und entlastet die Anfrageserver
der beteiligten Standorte. Die eigentlichen Anfragen werden außerdem mit Zuordnung zum Anfragenden
für einen Zeitraum von 2 Jahren gespeichert. Das FDPG erfasst die Anzahl und Häufigkeit von
Machbarkeitsanfragen durch die Forschenden, um der Re-Identifizierung von Personendaten und der
Suche nach Geschäftsgeheimnissen der beteiligten Standorte vorzubeugen.
<br />
(2) Falls Verdacht auf einen Missbrauch der Machbarkeitsanfragen-Funktionen besteht, nehmen das FDPG
aber auch die beteiligten Standorten Einsicht in die Query und die Ergebnisse. Auf Anfrage ist im
Verdachtsfall das FDPG verpflichtet, den Standorten die Identität des Anfragenden mitzuteilen.
<br />
Bei der Durchführung von Machbarkeitsanfragen werden verarbeitet:
<br />
• Query zu der Machbarkeitsanfrage
<br />
• Zeitpunkt der Versendung der Machbarkeitsanfrage
<br />
• Nutzer können selbst auch die Ergebnisse ihrer Machbarkeitsanfrage speichern.
<br />
(3) Im Zusammenhang mit der Durchführung von Machbarkeitsanfragen werden die folgenden Daten
verarbeitet:
<br />
• Die Identität des Nutzers wird vom FDPG erhoben und gespeichert.
<br />
• Die vom Nutzer gewählten Ein- und Ausschlusskriterien werden sowohl vom FDPG als auch von allen
beteiligten Standorten erhoben und gespeichert.
<br />
• Die Ergebnismengen einzelner Standorte werden dort und alle Ergebnismengen vom FDPG erhoben und
gespeichert.
<br />
• Der Zeitpunkt der Durchführung einer Machbarkeitsanfrage wird sowohl an allen beteiligten
Standorten als auch vom FDPG erhoben und gespeichert.
<br />
(4) Die im Zusammenhang mit der Durchführung von Machbarkeitsanfragen erhobenen und verarbeiteten
Daten werden spätestens zwei Jahre nach der Durchführung der Machbarkeitsanfrage gelöscht oder
anonymisiert.
<br />
(5) Alle an den beteiligten Standorten oder im FDPG im Rahmen der Nutzung des FDPG erhobenen Daten
werden nur zu den folgenden Zwecken verarbeitet:
<br />
• Überprüfung der Einhaltung der Nutzungsregeln des FDPG
<br />
• Sicherung des Portal-Betriebs und Planung des weiteren Ausbaus
<br />
• Nachweis der Nutzung durch den Portalbetreiber
<br />
<br />
<h4>3.2 Projektanträge und Projektverwaltung</h4>
Zur Bearbeitung von Projektanträgen wird eine größere Menge von Inhalten zu Ihrem jeweils geplanten
Forschungsprojekt erfasst (z.B. Projekttitel, Hypothese, Ethikvotum). Antragsstellende werden dem
Projekt als verantwortliche Mitarbeiter zugeordnet. Alle Kommunikation, die mit dem FDPG zu einem
Projekt erfolgt, wird diesem zugeordnet. Kommentare und Benachrichtigungen werden gespeichert. Wenn
die Rolle des verantwortlichen Mitarbeiters an eine andere Person übergeht, werden die gesamten
Projektinhalte an diese Person übertragen. Die Zuordnung wird im Transparenzportal der MII
öffentlich sichtbar gemacht. Mit dem Projektantrag wird für dieses Vorgehen vom Antragstellenden die
Zustimmung erfragt.
<br />
<br />
<br />
<h3>4 Umgang mit Cookies</h3>
Cookies sind kleine Informationsdateien, die Ihr Browser-Programm im eigenen Zugriffsbereich
(üblicherweise die Festplatte Ihres Computers) speichert und die bei Anfragen von zugehörigen
Webservern an diese übermittelt werden. Die Website des FDPGs speichert in einem solchen Cookie die
Adresse unserer Website sowie einfache Informationen zur Navigationsunterstützung, aus denen Dritte
Rückschlüsse auf die Adressen der aufgerufenen Seiten sowie den Zeitpunkt des Besuchs unserer
Website ziehen könnten. Sie speichert Cookies zum Zwecke der Nutzerauthentifizierung. Cookies lassen
sich mit allen Programmen zum Browsen im Internet steuern. Die meisten Browser-Programme sind so
eingestellt, dass alle Cookies akzeptiert werden, ohne die Benutzer zu fragen. Das Browsen unserer
öffentlich zugänglichen Seiten ist auch möglich, wenn Ihr Browser so eingestellt ist, dass Cookies
blockiert werden. Für den Zugang zu den geschützten Seiten, die eine Benutzeranmeldung erfordern,
muss Ihr Browser jedoch Cookies zulassen, solange Sie eingeloggt sind. Wir verwenden für den
Anmeldevorgang für registrierte Nutzer sogenannte Essential Cookies, die für den unmittelbaren
Betrieb der Webseite bei dem Anmeldevorgang nötig sind. Wir empfehlen, Ihr Browser-Programm so zu
konfigurieren, dass Cookies nach Beendigung des Programms gelöscht werden. Rechtsgrundlage für
unsere Verwendung von Cookies ist Art. 6 Abs.1 lit. f DSGVO. Die Nutzung von Cookies ist für uns ein
berechtigtes Interesse, da wir hierdurch unsere Website optimal gestalten und anpassen können. Somit
ist uns die Nutzung von Cookies solange gestattet, bis davon auszugehen ist, dass Ihre
schutzwürdigen Interessen eindeutig überwiegen. Sollte dies der Fall sein beenden wir die Nutzung
von Cookies. Auch im Hinblick auf Cookies stehen Ihnen natürlich die unter „Betroffenenrechte“
aufgeführten Rechte zu.
<br />
<br />
<br />
<h3>5 Übermittlung von Daten an Dritte</h3>
(1) Eine Übermittlung Ihrer persönlichen Daten an Dritte erfolgt nur zu den im Folgenden
aufgeführten Zwecken:
<br />
1. Es liegt eine ausdrückliche Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a DSGVO vor,
<br />
2. eine Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Wahrung unserer berechtigten Interessen
zulässig ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes schutzwürdiges Interesse
an der Nichtweitergabe Ihrer Daten haben,
<br />
3. für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche
Verpflichtung besteht, und
<br />
4. dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von
Vertragsverhältnissen mit Ihnen erforderlich ist.
<br />

<br />
(2) Nutzung von Microsoft Azure Cloud Services
<br />
Um den Nutzern des FDPG eine Vielzahl von Auswertungsfunktionen zur Verfügung stellen zu können,
nutzt das FDPG Azure Cloud Services der Fa. Microsoft. Hinweis: Personenbezogene Nutzerdaten werden
ausschließlich bei den unter Ziff. 2 genannten Stellen gespeichert. Eine Speicherung von
personenbezogenen Daten der Nutzer in der Microsoft Azure Cloud findet nicht statt.
<br />
Zur datenschutzkonformen Nutzung dieser Services wurde ein Vertrag zur Auftragsverarbeitung, indem
auch die aktuellen EU-Standardvertragsklauseln enthalten sind, Microsoft Products and Services Data
Protection Addendum (DPA), mit der Fa. Microsoft geschlossen. Dieser Vertrag gewährleistet, dass die
Fa. Microsoft die personenbezogenen Daten der Nutzer nur nach den Weisungen des FDPG und unter
Einhaltung der DSGVO verarbeitet. Nähere Informationen zu den Datenschutzbestimmungen der Fa.
Microsoft finden Sie unter:
https://www.microsoft.com/licensing/docs/view/Microsoft-Products-and-Services-Data-Protection-Addendum-DPA
und https://docs.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses. Die Verwendung
der Azure Cloud Services erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Das FDPG hat ein
berechtigtes Interesse an einer möglichst zuverlässigen Darstellung dieser Webseiten. Sofern eine
entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage
von Art. 6 Abs. 1 lit. a DS-GVO; die Einwilligung ist jederzeit widerrufbar.
<br />
<br />
<br />
<h3>6 Betroffenenrechte</h3>
Als Betroffener einer Datenverarbeitung stehen Ihnen verschiedene Rechte zu. Diese finden Sie in
Kapitel 3 der DSGVO. Im Einzelnen haben Sie folgende Rechte:
<br />
• Sie können von uns Auskunft über Ihre bei uns gespeichert Daten, sowie die Art und Weise der
Verarbeitung verlangen.
<br />
• Sie können die Berichtigung fehlerhaft gespeicherter Daten verlangen.
<br />
• Sie können die Löschung Ihrer bei uns gespeicherten Daten verlangen.
<br />
• Sie können die Einschränkung der Verarbeitung Ihrer bei uns gespeicherten Daten verlangen, sollten
wir diese auf Grund einer gesetzlichen Verpflichtung noch nicht löschen dürfen.
<br />
• Sie können unserer Verarbeitung Ihrer Daten bei uns widersprechen.
<br />
• Sie können von uns die Übertragung Ihrer Daten an einen Dritten verlangen.
<br />
• Sollten Sie in eine Datenverarbeitung ausdrücklich eingewilligt haben, können Sie diese
Einwilligung jederzeit widerrufen.
<br />
• Werden Ihre Daten gem. Art. 6 Abs. 1 lit. f DSGVO, d.h. wegen dem berechtigen Interesse an der
Durchführung unserer Geschäftsinteressen, verarbeitet, haben Sie die Möglichkeit gegen diese
Verwendung Widerspruch einzulegen. Sollten wir dann keine zwingend schutzwürdigen Gründe für die
Verarbeitung darlegen können, stellen wir die Verarbeitung ein.
<br />
• Sie haben das Recht, sich bei einer für Datenschutz zuständigen Aufsichtsbehörde über unsere
Verarbeitung personenbezogener Daten zu beschweren.
<br />
<br />
<h4>6.1 Widerspruch</h4>
Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen
die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. e
(Datenverarbeitung im öffentlichen Interesse) oder lit. f (Datenverarbeitung auf Grundlage einer
Interessenabwägung) DSGVO erfolgt, Widerspruch einzulegen.
<br />
Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei
denn, wir können zwingende berechtigte Gründe für die Verarbeitung nachweisen, die Ihre Interessen,
Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder
Verteidigung von Rechtsansprüchen.
<br />
Weiterhin haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen
die Sie betreffende Verarbeitung personenbezogener Daten, die bei uns zu wissenschaftlichen oder
historischen Forschungszwecken oder zu statistischen Zwecken gemäß Art. 89 Abs. 1 DS-GVO erfolgen,
Widerspruch einzulegen, es sei denn, eine solche Verarbeitung ist zur Erfüllung einer im
öffentlichen Interesse liegenden Aufgabe erforderlich.
<br />
Ihnen steht es zudem frei, im Zusammenhang mit der Nutzung von Diensten der
Informationsgesellschaft, ungeachtet der Richtlinie 2002/58/EG, Ihr Widerspruchsrecht mittels
automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet werden.
<br />
<br />
<h4>6.2 Widerruf</h4>
Sie haben das Recht, eine Einwilligung zur Verarbeitung personenbezogener Daten jederzeit mit
Wirkung für die Zukunft zu widerrufen.
<br />
<br />
<br />
<h3>7 Änderung der Datenschutzerklärung</h3>
Die datenschutzrechtlichen Maßnahmen unterliegen stets geänderten gesetzlichen bzw. behördlichen
Vorgaben und technischen Erneuerungen, weshalb es notwendig werden kann, diese Datenschutzerklärung
zu aktualisieren bzw. zu ändern.
<br />
<br />
<br />
<br />
